import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import '@fontsource/inter';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './components/ErrorBoundary';
import { MotionProvider } from './contexts/MotionContext';

// Pageview analytics only, and only when a key is configured (Vercel env var).
// Autocapture and session recording stay off so no visitor chat content can
// ever reach analytics (see AGENTS.md logging rules).
if (process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: 'https://us.i.posthog.com',
    defaults: '2025-05-24',
    autocapture: false,
    disable_session_recording: true,
    person_profiles: 'identified_only',
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <MotionProvider>
        <App />
      </MotionProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
